





























































import { Vue, Component } from "vue-property-decorator"
import excelrecipes from "@/data/recipes.json"
import formrecipes from "@/data/formRecipes.json"

const AppProps = Vue.extend({
	props: {}
})

@Component({
	components: {}
})
export default class App extends AppProps {
	recipes: RecipeObject[] = excelrecipes.concat(formrecipes);

	created() {
		this.$store.dispatch("setRecipes", this.recipes)
	}

	links = [
		{
			id: 3,
			text: "Opskrifter",
			page: "/recipes"
		},
		{
			id: 4,
			text: "Enhedsoversætter",
			page: "/unitconverter"
		},
		{
			id: 6,
			text: "Opret",
			page: "/create"
		},
		{
			id: 5,
			text: "Andre madlinks",
			page: "/links"
		}
	];
}
